import React from 'react';
import { Tooltip } from 'react-tooltip';
import MenuVerDiagnosticos from '../Diagnostico/MenuVerDiagnosticos';

export default function VerDiagnosticos(){
    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1 className="m-0">Diagnosticos</h1>
                    </div>
                    <div className="col-sm-6">
                        <ol className="breadcrumb float-sm-right">
                        <li className="breadcrumb-item"><a href="/">Inicio</a></li>
                        <li className="breadcrumb-item active">Diagnosticos</li>
                        </ol>
                    </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <div className="container-fluid">
                    <MenuVerDiagnosticos></MenuVerDiagnosticos>
                </div>
            </section>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}